







import { Vue, Component, Prop } from 'vue-property-decorator';
import WhiteBlueButton from '../../../components/button/WhiteBlueButton.vue';
import ReportIcon from '../../../components/icon/ReportIcon.vue';
@Component({ components: { WhiteBlueButton, ReportIcon } })
export default class ReportButton extends Vue {
  css_class = {
    'd-block': true,
    'w-805rem': true,
    'ls-0': true,
    'font-weight-700': true,
    'px-3': true,
    'py-0': true,
    'w-1105rem': true,
  };
}
